import { createReducer, createFeature, on } from "@ngrx/store";

import { pipelineAdapter } from "./pipeline.state";
import { pipelineActions } from "./pipeline.actions";

const initialState = pipelineAdapter.getInitialState({
  loading: false,
  error: null,
});

const reducer = createReducer(
  initialState,
  on(pipelineActions.findForSample, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(pipelineActions.findForSampleSuccess, (state, { pipelines }) => {
    return pipelineAdapter.upsertMany(pipelines, { ...state, loading: false, error: null });
  }),
  on(pipelineActions.findForSampleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

export const pipelineFeature = createFeature({
  name: "protocolPipelines",
  reducer,
});